import Component from '@glimmer/component';

interface FormationPartsProgramListComponentArgs {}

export default class FormationPartsProgramListComponent extends Component<FormationPartsProgramListComponentArgs> {
  inc = (value: number) => value + 1;
}
